import React from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { apiClient } from "~/api/client"
import type { User } from "~/types"

interface AuthenticatedLayoutProps {
  children: React.ReactNode
}

const AuthenticatedLayout: React.FC<AuthenticatedLayoutProps> = ({
  children,
}) => {
  const navigate = useNavigate()
  const location = useLocation()

  const currentUser: User | null = (() => {
    try {
      const userData = localStorage.getItem("current_user")
      return userData ? JSON.parse(userData) : null
    } catch {
      return null
    }
  })()

  const handleLogout = async () => {
    try {
      await apiClient.logout()
      localStorage.removeItem("current_user")
      navigate("/login")
    } catch {
      localStorage.removeItem("current_user")
      navigate("/login")
    }
  }

  const isActiveRoute = (path: string) => {
    if (path === "/") {
      return (
        location.pathname === "/" || location.pathname.startsWith("/entries/")
      )
    }
    return location.pathname.startsWith(path)
  }

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f5f5f5" }}>
      <div
        style={{
          backgroundColor: "white",
          padding: "16px 24px",
          borderBottom: "1px solid #ccc",
          marginBottom: "24px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
          <h1 style={{ margin: 0 }}>Chip 🐿️</h1>
          <div
            style={{
              height: "24px",
              width: "1px",
              backgroundColor: "#ccc",
            }}
          />
          <button
            type="button"
            onClick={() => navigate("/")}
            style={{
              padding: "8px 16px",
              backgroundColor: "white",
              color: "#333",
              border: "none",
              fontSize: "14px",
              fontWeight: 600,
              cursor: "pointer",
              textDecoration: isActiveRoute("/") ? "underline" : "none",
            }}
          >
            Knowledge
          </button>
          <button
            type="button"
            onClick={() => navigate("/chat")}
            style={{
              padding: "8px 16px",
              backgroundColor: "white",
              color: "#333",
              border: "none",
              fontSize: "14px",
              fontWeight: 600,
              cursor: "pointer",
              textDecoration: isActiveRoute("/chat") ? "underline" : "none",
            }}
          >
            Chat
          </button>
        </div>
        <div style={{ display: "flex", gap: "8px" }}>
          {currentUser?.admin && (
            <button
              type="button"
              onClick={() => navigate("/admin")}
              style={{
                padding: "8px 16px",
                backgroundColor: "#6c757d",
                color: "white",
                border: "none",
                borderRadius: "8px",
                fontSize: "14px",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Admin
            </button>
          )}
          <button
            type="button"
            onClick={handleLogout}
            style={{
              padding: "8px 16px",
              backgroundColor: "#dc3545",
              color: "white",
              border: "none",
              borderRadius: "8px",
              fontSize: "14px",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Logout
          </button>
        </div>
      </div>
      {children}
    </div>
  )
}

export default AuthenticatedLayout
